import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import cartItemsAdapter from "@/redux/slice/cart/adapter/cartItem";

const selectCart = (state: RootState) => state?.cart;

const selectCartItems = createDraftSafeSelector(selectCart, (cart) => cart?.cartItems);

// Export the customized selectors for patientDetails adapter using `getSelectors`
export const {
  selectAll: cartItemsSelector,
  selectById: selectCartItemsBySkuId,
  selectIds: selectCartItemsSkuIds,
  selectTotal: selectCartItemCount,
} = cartItemsAdapter.getSelectors(
  // Pass in a selector that returns the patientDetails field of auth slice of state
  selectCartItems
);
